
import React from 'react';
import { FormHelperText } from '@mui/material';
import { LoaderMini } from '~/components/Loaders';
import history from '~/services/history';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import EsteiraComponent from './EsteiraComponent';

/* eslint-disable */


function Primeiro(props) {
	const {documento, setDocumento, errorMessage, setErrorMessage, step, verifyDocument, loading} = props;


	function getBackPage() {
		history.push('login');
	}

	function applyMask(value) {
		value = value.replace(/[^A-Z0-9]/g, '');

		if(value.length <= 11){
			if (value.length === 11) {
				validarCpf(value)
			}
			return value.replace(/([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{2})/, "$1.$2.$3-$4");
		}

		validarCnpj(value)
		return value.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, "$1.$2.$3/$4-$5");
	}

	function validarCpf(cpf) {
		cpf = cpf.replace(/[^A-Z0-9]/g, '');

		if (cpf.length !== 11) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		if (/^(\d)\1{10}$/.test(cpf)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		let soma = 0;
		let resto;

		for (let i = 0; i < 9; i++) {
		  soma += parseInt(cpf.charAt(i), 10) * (10 - i);
		}
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) {
		  resto = 0;
		}
		if (resto !== parseInt(cpf.charAt(9), 10)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		soma = 0;
		for (let i = 0; i < 10; i++) {
		  soma += parseInt(cpf.charAt(i), 10) * (11 - i);
		}
		resto = (soma * 10) % 11;
		if (resto === 10 || resto === 11) {
		  resto = 0;
		}
		if (resto !== parseInt(cpf.charAt(10), 10)) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
		  	return false;
		}

		setErrorMessage('')
		return true;
	  }

	function validarCnpj(cnpj) {
		cnpj = cnpj.replace(/[^A-Z0-9]/g, '');
		if (cnpj.length !== 14) {
			setErrorMessage('Não foi possível concluir sua solicitação. Tente novamente mais tarde ou contate o suporte.')
			return false;
		}
		
		setErrorMessage('')
		const regex = /^([A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2})$/;

		return regex.test(cnpj);
	}

	return (
		<div className="w-100">
			<FormGroup>
				<Label>Digite o seu CPF/CNPJ</Label>
				<Input
					id="documento-token"
					placeholder="Somente números"
					style={{borderColor:errorMessage ? 'red' : 'gray'}}
					value={documento}
					onChange={(elemento) => {
							setErrorMessage('')
							const newValue = applyMask(elemento.target.value)
							setDocumento(newValue)
						}
					}
				/>
				{errorMessage && (
					<FormHelperText>
						<i style={{ color: "red"}}>{errorMessage}</i>
					</FormHelperText>
				)}

			</FormGroup>


			<EsteiraComponent step={step} />

			<Row className="rowButton">
				<Col>
					<Button
						outline
						color="primary"
						className="buttonComponentOutline px-5"
						onClick={() => getBackPage()}>
						VOLTAR
					</Button>
				</Col>
				<Col>
					<Button
						color="primary"
						className="buttonComponent px-5"
						disabled={(documento.replace(/[^A-Z0-9]/g, '').length !== 11 && documento.replace(/[^A-Z0-9]/g, '').length !== 14) || errorMessage.length > 0 || loading}
						onClick={() => {
							verifyDocument()
							}}>

						{!loading ? 'ENVIAR' : <LoaderMini width="20" /> }

					</Button>
				</Col>
			</Row>
		</div>
	);
}

export default Primeiro;
